import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Appointments Today ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_timeline_item = _resolveComponent("v-timeline-item")!
  const _component_v_timeline = _resolveComponent("v-timeline")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    style: {"margin":"0px","padding":"0px","width":"100%"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_layout, { wrap: "" }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_v_timeline, {
            side: "end",
            size: "small"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                return (_openBlock(), _createBlock(_component_v_timeline_item, {
                  key: item.id,
                  "dot-color": item.color,
                  size: "small"
                }, {
                  icon: _withCtx(() => [
                    (item.id===1)
                      ? (_openBlock(), _createBlock(_component_v_avatar, {
                          key: 0,
                          image: "https://i.pravatar.cc/64"
                        }))
                      : _createCommentVNode("", true),
                    (item.id===3)
                      ? (_openBlock(), _createBlock(_component_v_avatar, {
                          key: 1,
                          image: "https://i.pravatar.cc/65"
                        }))
                      : _createCommentVNode("", true),
                    (item.id===4)
                      ? (_openBlock(), _createBlock(_component_v_avatar, {
                          key: 2,
                          image: "https://i.pravatar.cc/66"
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  opposite: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(item.time), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      class: "elevation-2 rounded-xl",
                      width: "700px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_title, { class: "text-h5" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.patient.name), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_card_text, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.patient.problemSummary), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_card_text, null, {
                          default: _withCtx(() => [
                            (item.patient.name)
                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                  key: 0,
                                  color: "jamzcare",
                                  class: "rounded-xl",
                                  variant: "tonal",
                                  to: "/patient-detail"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Detail ")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["dot-color"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}